<template>
  <el-dialog :before-close="noDialog" :fullscreen="dialogFullscreen" :visible.sync="dialog" title="编辑子代理">
    <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="auto">
      <el-form-item label="父运营商抽成比例" prop="baseAgentDividendRaton">
        <el-input v-model.number="editForm.baseAgentDividendRaton">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="editPost">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import agentEditChildAgent from "@/api/user/agent-manage/agentEditChildAgent";
import {oneToHundred} from "@/utils/check";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  name: "editChildAgentDialog",
  props: {
    row: Object
  },
  mixins: [dialogMixin, resDisposeMixin],
  watch: {
    row() {
      this.editForm.id = this.row.id;
      this.editForm.baseAgentDividendRaton = this.row.baseAgentDividendRaton;
    }
  },
  data() {
    return {
      editRules: {
        baseAgentDividendRaton: [
          {required: true, message: '请输入父运营商抽成比例'},
          {type: 'number', message: '必须为数字值'},
          {required: true, validator: oneToHundred}
        ],
      },
      editForm: {
        id: undefined,
        baseAgentDividendRaton: undefined
      }
    }
  },
  methods: {
    editPost() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          agentEditChildAgent(this.editForm).then(res => {
            this.resNoDialog({res})
          })
        }
      })
    }
  }
}
</script>
